import { z } from "zod";
import type { infer as zInfer } from "zod";

export const eventCount = z.object({
  prematch: z.number().optional(),
  live: z.number().optional(),
});

export type EventCount = zInfer<typeof eventCount>;
